











































import { Component, Mixins, Prop } from 'vue-property-decorator';
import GlobalMixins from '@/plugins/mixins';

@Component({
	components: {
	},
})
export default class SettingLink extends Mixins(GlobalMixins) {

	@Prop(String) public keyname!: string;
	@Prop(String) public title!: string;
	@Prop(String) public icon!: string;

	get path() {
		return `/dashboard/setting/${this.keyname}`;
	}

}
